<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-union`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 5v9H4a2 2 0 00-2 2v26a2 2 0 002 2h28a2 2 0 002-2v-9h9a2 2 0 002-2V5a2 2 0 00-2-2H15a2 2 0 00-2 2zm4 2h24v22h-9a2 2 0 00-2 2v9H6V18h8.999a2 2 0 002-2V7z"/></svg>
</template>
<script>

export default {
  name: 'IconUnion',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
